import { useCallback } from 'react';
import UDButton from 'ud-ui/components/button';
import UDTippy from 'ud-ui/components/tippy';

export interface SwitchOrganizerButtonProps {
  /** Полная подпись «Переключиться на {имя}»: видна целиком, пока помещается, и всегда — в `aria-label` и подсказке. */
  label: string;
  onClick: () => void;
}

/**
 * Кнопка шапки карточки организатора. Длинное имя (до 40+ символов) обрезается многоточием, а не переносит подпись
 * на вторую строку 36-пиксельной кнопки (IMGM-1610). Полное имя остаётся доступным: в `aria-label` — для
 * скринридера, в подсказке — по наведению и Tab-фокусу; подсказка показывается только когда подпись обрезана.
 */
export function SwitchOrganizerButton({ label, onClick }: SwitchOrganizerButtonProps) {
  // `false` из `onShow` отменяет показ: подпись помещается целиком — подсказка повторила бы её.
  const showOnlyWhenTruncated = useCallback((instance: { reference: Element }) => {
    const text = instance.reference.querySelector('span');
    const isTruncated = text ? text.scrollWidth > text.clientWidth : false;
    return isTruncated ? undefined : false;
  }, []);

  return (
    <UDTippy content={label} placement="bottom" onShow={showOnlyWhenTruncated}>
      <UDButton
        onClick={onClick}
        className={'flex-center max-w-80 min-w-0 shrink-0'}
        variant={'primary'}
        style={{ height: 36 }}
        aria-label={label}
      >
        <span className="min-w-0 truncate">{label}</span>
      </UDButton>
    </UDTippy>
  );
}

export default SwitchOrganizerButton;
